export const RESET_PHASE_AFTER_CLOSE_MS = 200
